import { Pipe, PipeTransform } from '@angular/core';
import { College, HighSchool, TeamType } from '@athlete-x/definitions';
import { TeamHelper } from '@athlete-x/shared/classes/TeamHelper';

interface GroupedTeams {
    [key: string]: HighSchool | College
}

@Pipe({
    name: 'teamsSchools',
    standalone: true
})
export class TeamsSchoolsPipe implements PipeTransform {

    transform(teams: Array<any>): Array<any> {
        if (!teams?.length) {
            return teams;
        }

        const colleges: GroupedTeams = {};
        const high_schools: GroupedTeams = {};

        for(const team of teams) {
            const type = TeamHelper.teamType(team);
            if (type === TeamType.COLLEGE) {
                if (!colleges[team[type].id]) {
                    colleges[team[type].id] = team[type];
                }

            } else if (type === TeamType.HIGH_SCHOOL) {
                if (!high_schools[team[type].id]) {
                    high_schools[team[type].id] = team[type];
                }
            }
        }

        return [
            ...Object.values(colleges),
            ...Object.values(high_schools),
        ];
    }

}
